import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconMenu({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M3.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM8.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
        </svg>
    );
}

export default IconMenu;
